
var notificationWorker;
var notificationSW;

function setupNotifications() {
if('serviceWorker' in navigator) {
   navigator.serviceWorker
             .register('/portal/notification_sw.js', )
             .then(function(swReg) {
               notificationSW = swReg;
               console.log("Service Worker Registered"); });
              // swReg.update();
}

if ('Notification' in window) {

    Notification.requestPermission(function (permission) {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        var notificationWorker = new SharedWorker("/portal/notification_sharedworker.js");
        notificationWorker.port.start();
        notificationWorker.port.postMessage({name:"init", scheme:window.location.protocol, host:window.location.host, });

        notificationWorker.onerror = function(event){
          console.log(event);
        }
      }
    });
  }
}
